import * as React from 'react';
import { ExperienceWrapper, ProfessionalExperienceSectionWrapper, ProfessionalSectionEntriesWrapper } from './ExperienceStyles';
import { language } from './ExperienceLanguage';
import { ProfessionalExperienceEntriesType, ProfessionalExperienceEntryType } from '../../../../Types/ProfessionalExperienceLineType';
import { useSearchParams } from 'react-router-dom';
import { Props as SectionTitleProps, SectionTitleLayout } from '../SectionTitle/SectionTitleLayout';
import { ProfessionalExperienceEntry, Props as ProfessionalExperienceEntryProps } from './ExperienceEntry/ExperienceEntry';

export type Props = {
	professionExperienceSchema: ProfessionalExperienceEntriesType;
};

export const ExperienceLayout = (props: Props) => {
	const [searchParams, setSearchParams] = useSearchParams();
	const render = () => {
		let stupidTempVar = searchParams.get('subtype') ? searchParams.get('subtype') : searchParams.get('subType');

		const subtype = stupidTempVar ? stupidTempVar : 'standard';
		const sectionTitleProps: SectionTitleProps = {
			text: language.title,
			fullWidth: true,
		};
		const professionsExperienceEntries = generateProfessionalExperienceEntries(subtype, props.professionExperienceSchema);

		const returnValue = (
			<ProfessionalExperienceSectionWrapper>
				<SectionTitleLayout {...sectionTitleProps} />
				<ProfessionalSectionEntriesWrapper>{professionsExperienceEntries}</ProfessionalSectionEntriesWrapper>
			</ProfessionalExperienceSectionWrapper>
		);
		return returnValue;
	};
	const outerReturnValue = render();
	return outerReturnValue;
};

const generateProfessionalExperienceEntries = (subtype: string, entries: ProfessionalExperienceEntriesType) => {
	const returnValue = entries.map((theEntry: ProfessionalExperienceEntryType, index: number) => {
		const lineProps: ProfessionalExperienceEntryProps = {
			entry: theEntry,
			subtype: subtype,
			odd: index % 2 === 0,
		};
		const innerReturnValue = <ProfessionalExperienceEntry {...lineProps} />;
		return innerReturnValue;
	});
	return returnValue;
};
